//VendorTestimonialSectionBottom
import React from "react";
import VendorTestimonialSectionTop from "./VendorTestimonialSectionTop";
import VendorTestimonialsLocked from "./VendorTestimonialsLocked";
import Pagination from "../../../Common/PaginationPremium";
import { connect } from "react-redux";
import { updateTestimonialReviews } from "../../../../store/actions/vendorTestimonialActions";
import Loader from "../../../Common/Loader";
import SponsoredBox from "../../../Common/PeerBoxes/SponsoredBox";
import CompetitorBoxes from "../../../Common/PeerBoxes/CompetitorBoxes";
import SearchResultPremium from "../../../Common/SearchResultPremium";

class VendorTestimonialSectionBottom extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      paginationOn: 1,
      itemOnPage: 15,
      totalReferences: 77,
      currentlyShowing: "1-12",
      isLoader: false,
    };
    this.updateState = this.updateState.bind(this);
    this.toggleLoader = this.toggleLoader.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  updateState = (newValues) => {
    if (this._isMounted) {
      this.setState((prevState) => {
        return {
          ...prevState,
          ...newValues,
        };
      });
    }
  };

  toggleLoader = () => {
    if (this._isMounted) {
      this.setState((prevState) => {
        return { isLoader: !prevState.isLoader };
      });
    }
  };

  setPaginationOn = (number) => {
    this.setState({ paginationOn: number });
  };

  setItemOnPage = (iValue) => {
    this.setState({ itemOnPage: iValue });
  };

  isFirstCharInRangeAtoJ(str) {
    if (str && str.length > 0) {
      let firstChar = str.charAt(0).toUpperCase();
      return firstChar >= "A" && firstChar <= "J";
    }
    return false; // Return false for empty, null, or undefined strings
  }

  ShowContentOnTestimonial = (CSSnap, URLPathname) => {
    if (Object.keys(CSSnap).length > 0 && !!URLPathname) {
      let vendorSlug = URLPathname.split("/")[2];

      if (this.isFirstCharInRangeAtoJ(vendorSlug)) {
        if (!!CSSnap?.testimonial_content) {
          return this.ShowCaseTestimonialOverviewType1(
            CSSnap?.testimonial_content,
            URLPathname
          );
        } else {
          return (
            <p>
              Browse {this.props.vendorCommon.name} testimonials and customer
              references to help make the right purchasing decision
            </p>
          );
        }
      } else {
        if (!!CSSnap?.testimonial_content) {
          return this.ShowCaseTestimonialOverviewType5(
            CSSnap?.testimonial_content,
            URLPathname
          );
        } else {
          return (
            <p>
              Browse {this.props.vendorCommon.name} testimonials and customer
              references to help make the right purchasing decision
            </p>
          );
        }
      }
    }
  };

  ShowCaseTestimonialOverviewType1 = (content) => {
    return (
      <>
        <h2>Testimonials Overview</h2>
        {content.map((ContentObject) => (
          <>
            <h3>{ContentObject.heading}</h3>
            <p>{ContentObject.content}</p>
          </>
        ))}
      </>
    );
  };

  ShowCaseTestimonialOverviewType5 = (content) => {
    let leftCS = [];
    let rightCS = [];

    for (let a = 0; a < content.length; a++) {
      if (!Boolean(a % 2)) {
        leftCS.push(content[a]);
      } else {
        rightCS.push(content[a]);
      }
    }
    return (
      <>
        <h2>Testimonials Overview</h2>
        <div class="accordion-single js-acc-single accordion-toggle disabledHeading">
          <div className="left">
            {leftCS.map((content) => (
              <div class="accordion-single-item js-acc-item">
                <h3 class="accordion-single-title js-acc-single-trigger">
                  {content.heading}
                </h3>
                <div class="accordion-single-content">
                  <div className="accordion-single-content">
                    <p>{content.content}</p>
                  </div>
                </div>
                <span class="acc-toggle"></span>
              </div>
            ))}
          </div>
          <div className="right">
            {rightCS.map((content) => (
              <div class="accordion-single-item js-acc-item">
                <h3 class="accordion-single-title js-acc-single-trigger">
                  {content.heading}
                </h3>
                <div class="accordion-single-content">
                  <div className="accordion-single-content">
                    <p>{content.content}</p>
                  </div>
                </div>
                <span class="acc-toggle"></span>
              </div>
            ))}
          </div>
        </div>
      </>
    );
  };

  render() {
    return (
      <React.Fragment>
        <section>
          <div className="middleSection vendor_testimonials_section vendor_testimonials_section_verified">
            <div className="container">
              {/* <div className="vendor_portal_top_header_block">
                <div className="vendor_portal_top_header_block">
                  {this.ShowContentOnTestimonial(
                    this.props.vendorTestimonials,
                    this.props?.location?.pathname
                  )}
                </div>
              </div> */}
              <div className="vendor_reviews_section testimonials">
                <div className="testimonial_reviews clsVerified">
                  <div className="first_three_columns">
                    <VendorTestimonialSectionTop
                      {...this.props}
                      {...this.state}
                    />
                  </div>
                  {this.props.vendorCommon.show_sponsored_popup ? (
                    <SponsoredBox {...this.props.vendorCommon} />
                  ) : (
                    <CompetitorBoxes {...this.props.vendorCommon} />
                  )}

                  <div className="vendor_list">
                    {/* <VendorTestimonialSectionTop {...this.props} {...this.state} /> */}

                    <VendorTestimonialsLocked {...this.props} {...this.state} />
                  </div>
                </div>
              </div>
              <Pagination
                {...this.props}
                paginationOn={this.state.paginationOn}
                setPaginationOn={this.setPaginationOn}
                itemOnPage={this.state.itemOnPage}
                setItemOnPage={this.setItemOnPage}
                pageData={Array.apply(
                  null,
                  Array(this.props?.vendorTestimonials?.pagination?.num_pages)
                ).map((val, idx) => ({ page: idx + 1 }))}
                paginationInfo={this.props.vendorTestimonials.pagination}
                toggleLoader={this.toggleLoader}
              />
            </div>
          </div>
        </section>

        {/* {this.state.isLoader ? <Loader /> : null} */}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    vendorCommon: state.vendorCommon,
    vendorTestimonials: state.vendorTestimonials,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateReview: (URL, pagenumber) =>
      dispatch(updateTestimonialReviews(URL, pagenumber)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorTestimonialSectionBottom);
